import { render, staticRenderFns } from "./report-panel.vue?vue&type=template&id=c504dac2&"
import script from "./report-panel.vue?vue&type=script&lang=js&"
export * from "./report-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports